import React, { useState } from 'react';
import { Card, Button, Form, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';
import '../Styles/TrackMyOrder.css';
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaInstagram, FaYoutube, FaHeadphones } from "react-icons/fa";

const TrackMyOrder = () => {
  const [awb, setAwb] = useState('');
  const [trackingData, setTrackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleTrack = async () => {
    if (!awb) {
      setError('Please enter an AWB number');
      return;
    }

    setError('');
    setLoading(true);
    try {
      const response = await axios.get(`https://backend-matihaat.onrender.com/api/shiprocket/track/${awb}`);
      setTrackingData(response.data);
    } catch (err) {
      setError('Failed to track the order. Please check the AWB number. If the issue persists, please contact customer support at +91919654870373');
    } finally {
      setLoading(false);
    }
  };

  const shipment = trackingData?.tracking_data?.shipment_track?.[0];
  const activities = trackingData?.tracking_data?.shipment_track_activities || [];

  return (
    <div>
    <div className="track-order-container">
      <Card className="track-card">
        <Card.Body>
          <Card.Title className="text-center mb-4">📦 Track My Order</Card.Title>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Enter AWB Number</Form.Label>
              <Form.Control
                type="text"
                value={awb}
                onChange={(e) => setAwb(e.target.value)}
                placeholder="e.g. 1234567890"
              />
            </Form.Group>
            <Button variant="primary" onClick={handleTrack} disabled={loading}>
              {loading ? <Spinner size="sm" animation="border" /> : 'Track'}
            </Button>
          </Form>
          {error && <Alert variant="danger" className="mt-3">{error}</Alert>}

          {shipment && (
            <div className="tracking-details mt-4">
              <h5>Status: {shipment.current_status || 'N/A'}</h5>
              <p><strong>AWB:</strong> {shipment.awb_code}</p>
              <p><strong>Courier:</strong> {shipment.courier_name}</p>
              <p><strong>Destination:</strong> {shipment.destination}</p>
              <p><strong>Delivered To:</strong> {shipment.delivered_to}</p>
              <p><strong>Expected Delivery:</strong> {shipment.edd || 'Not Available'}</p>
              <p><strong>Tracking Link:</strong> <a href={trackingData.tracking_data.track_url} target="_blank" rel="noreferrer">View Tracking</a></p>
              <hr />
              <h6>Tracking History:</h6>
              <ul>
                {activities.map((activity, idx) => (
                  <li key={idx}>
                    {activity.date} - {activity.activity} ({activity.location})
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Card.Body>
      </Card>
      
    </div>
     <footer style={{ backgroundColor: "#f9f9f9", color: "#2b2b2b", padding: "40px 0" }}>
      <Container>
        <Row className="text-center text-md-start">
          {/* Left Column */}
          <Col md={4} className="mb-4 mb-md-0">
            <img
              src="https://matifoods.in/wp-content/uploads/2022/04/Mati-Haat-Web-Logo-2.png"
              alt="Mati Haat"
              style={{ width: "130px", marginBottom: "20px" }}
            />
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <FaHeadphones style={{ color: "#8BC34A", fontSize: "30px", marginRight: "10px" }} />
              <div>
                <p className="mb-0">Got Questions? Call us 24/7!</p>
                <strong>+91 9654870373</strong>
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-center justify-content-md-start gap-3">
              <a href="https://www.facebook.com/profile.php?id=61550736893804" style={{ color: "#000" }} className=" fs-5" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.instagram.com/matihaat/" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.youtube.com/@FarmingwithMatihaat" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
          </Col>

          {/* Middle Column - Quick Links */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 style={{ color: "#7BA127" }}>Quick Links</h5>
            <ul className="list-unstyled">
              <ul className="list-unstyled">
                <li><a href="/about-us" style={{ color: "#000" }} className="text-decoration-none">About Us</a></li>
                <li><a href="/contact-us" style={{ color: "#000" }} className="text-decoration-none">Reach Us</a></li>
               
                
                
                <li><a href="/track-order" style={{ color: "#000" }} className="text-decoration-none">Track your Order</a></li>
              </ul>
            </ul>
          </Col>

          {/* Right Column - Customer Care */}
          <Col md={4}>
            <h5 style={{ color: "#7BA127" }}>Customer Care</h5>
            <ul className="list-unstyled">
              <li><a href="/privacy-policy" style={{ color: "#000" }} className="text-decoration-none">Privacy Policy</a></li>
              <li><a href="/shipping-policy" style={{ color: "#000" }} className="text-decoration-none">Shipping Policy</a></li>
              <li><a href="/refund-policy" style={{ color: "#000" }} className="text-decoration-none">Refund and Returns Policy</a></li>
              <li><a href="/payment-methods" style={{ color: "#000" }} className="text-decoration-none">Payment Methods</a></li>
              <li><a href="/terms-and-conditions" style={{ color: "#000" }} className="text-decoration-none">Terms and Conditions</a></li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
    </div>
  );
};

export default TrackMyOrder;
